import { OnInit } from '@angular/core';
import { UserProfileService } from './user-profile.service';
import { LanguageService } from '../../../core/language/language.service';
import { AuthService } from '../../../core/auth/auth.service';
import { ItauUserIdleService } from '../../../core/security/itau-user-idle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { normalizePath } from '@app/shared/utils';
import { Router } from '@angular/router';
var defaultSiteLanguage = 'br';
var UserProfileComponent = /** @class */ (function () {
    function UserProfileComponent(service, itauUserIdleService, languageService, authService, _window, _sdkAnalyticsService, router) {
        this.service = service;
        this.itauUserIdleService = itauUserIdleService;
        this.languageService = languageService;
        this.authService = authService;
        this._window = _window;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.router = router;
        this.canChangeManager = false;
    }
    UserProfileComponent.prototype.logout = function () {
        if (this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: "perfil-configuracoes:logout"
            });
        }
        this.itauUserIdleService.stopWatching();
        this.authService.logout(true);
    };
    UserProfileComponent.prototype.changeSiteLanguage = function (event, language) {
        if (language && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: "perfil-configuracoes:idioma:" + language
            });
        }
        event.stopPropagation();
        this.setLanguage(language);
        this.service.changeSiteLanguage(language);
    };
    UserProfileComponent.prototype.setMenuOpened = function (isClosed) {
        this.isMenuClosed = isClosed;
    };
    UserProfileComponent.prototype.ngOnInit = function () {
        if (this.authService.currentUserValue && this.authService.currentUserValue.permiteTrocaGestor) {
            this.canChangeManager = true;
        }
    };
    Object.defineProperty(UserProfileComponent.prototype, "siteLanguage", {
        get: function () {
            return this.languageService.siteLanguage ? this.languageService.siteLanguage : defaultSiteLanguage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileComponent.prototype, "languageIsBR", {
        get: function () {
            return this.siteLanguage === 'br';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileComponent.prototype, "languageIsUS", {
        get: function () {
            return this.siteLanguage === 'us';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileComponent.prototype, "languageIsES", {
        get: function () {
            return this.siteLanguage === 'es';
        },
        enumerable: true,
        configurable: true
    });
    UserProfileComponent.prototype.setLanguage = function (language) {
        this.language = language.toLowerCase();
    };
    UserProfileComponent.prototype.changeManager = function () {
        if (this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: "perfil-configuracoes:troca-gestor"
            });
        }
        this.changeManagerUrl = this.authService.currentUserValue.permiteTrocaGestor;
        var titleChangeManager = this.languageService.translate('titleChangeManager.TITLE');
        this._window.open(this.changeManagerUrl, titleChangeManager, 'width=800,height=600');
        this._sdkAnalyticsService.trackEvent('screen_view', {
            custom_path: '/iss/lg/pesquisadegestor',
            implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
            detail: 'perfil-configuracoes:troca-gestor'
        });
    };
    return UserProfileComponent;
}());
export { UserProfileComponent };
